module.exports = __webpack_public_path__ + "8211d6a134593a8b749f874ac956ab92.svg";